export const TENANT = {
  coa: 'coa',
  santafecountynm: 'santafecountynm',
  santafenm: 'santafenm',
  gsdnm: 'gsdnm',
  frankfortky: 'frankfortky',
  uwc: 'uwc',
  dev: 'dev',
  demo: 'demo',
};

export const PRODUCTION_TENANTS = Object.values(TENANT);

/** UWC billed data is 2023 — dashboard year pickers start here on that tenant only. */
export const UWC_DEFAULT_DASHBOARD_YEAR = 2023;

/** Region/state label shown on the map badge and dashboard landing card. */
export function getTenantRegionLabel(tenantId?: string): string {
  if (tenantId === TENANT.uwc) return 'Wisconsin';
  return 'New Mexico';
}
